(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule')
		.directive('beforeAfterSliderHandle', [
			'$document',
			'$timeout',
			'mixpanelFactory',
			'STATIC_BASE_PATH',
			beforeAfterSliderHandleFunction
		]);

	function beforeAfterSliderHandleFunction(
		$document,
		$timeout,
		mixpanelFactory,
		STATIC_BASE_PATH) {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/view-plan/before-after-slider-handle.html',
			scope: {
				elementWidth: '=',
				overlayWidth: '='
			},
			link: function ($scope, $elem, $attrs) {
				if(angular.isDefined($scope.elementWidth)) {
					initHandle();
				} else {
					var unregister = $scope.$watch('elementWidth', function(newWidth) {
						if(angular.isDefined(newWidth)) {
							unregister();
							initHandle();
						}
					});
				}

				function initHandle() {
					var containerLimitRight = $scope.elementWidth;
					var startX = $scope.elementWidth / 2;
					var positionX = startX;
					var touchScreen = false;

					$elem.css({
						left: positionX + 'px'
					});

					$elem.on('mousedown', function(event) {
						event.preventDefault();
						startX = event.pageX - positionX;
						$document.on('mousemove', moveIcon);
						$document.on('mouseup', releaseIcon);
					});

					$elem.on('touchstart', function(event){
						event.preventDefault();
						startX = event.touches[0].pageX - positionX;
						touchScreen = true;
						$document.on('touchmove', moveIcon);
						$document.on('touchend', releaseIcon);
					});

					function moveIcon(event) {
						positionX = touchScreen ? event.touches[0].pageX - startX : event.pageX - startX;

						if(positionX < 0) {

							$scope.$apply(function(){
								$scope.overlayWidth = 0;
							});
							
							$elem.css({
								left: 0 + 'px'
							});

							positionX = 0;

						} else if(positionX >= containerLimitRight) {

							$scope.$apply(function(){
								$scope.overlayWidth = containerLimitRight;
							});
							
							$elem.css({
								left: containerLimitRight + 'px'
							});

							positionX = containerLimitRight;

						} else {

							$scope.$apply(function(){
								$scope.overlayWidth = parseInt(positionX);
							});
							
							$elem.css({
								left: positionX + 'px'
							});
						}
					}

					function releaseIcon(){
						if (touchScreen){
							$document.off('touchmove', moveIcon);
							$document.off('touchend', releaseIcon);
						} else {
							$document.off('mousemove', moveIcon);
							$document.off('mouseup', releaseIcon);
						}

						mixpanelFactory.track('Slider Used', {
							Section: $scope.mixpanelContainer
						});
					}
				}
			}
		};
	}
})(window.angular);